import { isOnFirstLineOfParentNode } from 'components/horizontal-move-list/move-node/utils/is-on-first-line-of-parent-node';
import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create the move variation up action
 */
export function createMoveVariationUpAction(
  _store: Store,
  _storeActions: StoreActions,
): ContextMenu.Action {
  return {
    action: CONTEXT_MENU_ACTION_NAMES.MoveVariationUp,
    handler,
    isVisible,
    getDisplayName: () => MoveList.Translation.Actions.MoveVariationUp,
  };

  /**
   * Only show this when the node is not on the main line
   * AND when the node's parent has more lines in its lines array than the current line
   * because there would be nowhere to move the lines
   * AND when the node is not on the first line of its parent node's lines because
   * we would not be able to move this line up any further
   */
  function isVisible({ game, node }: ContextMenu.ActionHandlerContext) {
    if (node.ids.line === 0) {
      return false;
    }

    const line = game.getLine(node.ids.line);

    if (!line) {
      return false;
    }

    const parentNode = game.getNodeByIds({
      line: <number>line.parentId,
      move: <number>line.atMoveNode,
    });

    if (!parentNode) {
      return false;
    }

    const parentHasOtherLines = parentNode.lines && parentNode.lines.length > 1;

    if (parentHasOtherLines) {
      return !isOnFirstLineOfParentNode(node, parentNode);
    }

    return false;
  }

  /**
   * Move a variation up
   */
  function handler({ node, game }: ContextMenu.ActionHandlerContext): void {
    game.moveVariation(node.ids.line, true);
  }
}
